import { useSelectedVideo } from '.';
import { useVideoPlayButton } from './useVideoPlayButton';

export const usePlayChannelText = (): string | undefined => {
  const { selectedVideo } = useSelectedVideo();
  const { canPlay, playText } = useVideoPlayButton(selectedVideo);
  return canPlay ? playText : undefined;
};
